import script from "./company-update-form.vue?vue&type=script&setup=true&lang=ts"
export * from "./company-update-form.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__